/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Tournated Dashboard API
 * Internal REST API consumed by the Tournated dashboard. Authenticated with a user JWT (Authorization: Bearer ...).
 * OpenAPI spec version: 1.0
 */

/**
 * Question field type. Closed set — see enum values.
 */
export type AdditionalQuestionFieldType =
  (typeof AdditionalQuestionFieldType)[keyof typeof AdditionalQuestionFieldType];

export const AdditionalQuestionFieldType = {
  Text: "Text",
  Number: "Number",
  Select: "Select",
  File: "File",
} as const;
